import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { usePostUpdatePaymentTermTemplateMutation,useGetItemDetailsDataMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import FileAttachmentManager  from "../../../../Components/FileAttachmentManager";
import Attachment from "../../../../utils/Attachment";
const EditForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
          const IdData = location.state?.ItemId;
          const [podata, setpodata] = useState('')
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [UpdatePaymentTermsTemplate] = usePostUpdatePaymentTermTemplateMutation();

  // tab1
  const [TemplateName, setTemplateName] = useState("");
  const [AllocatePaymentBasedOnPaymentTerms, setAllocatePaymentBasedOnPaymentTerms] = useState("");
  const [selected_payment_term_data, setselected_payment_term_data] = useState([]);
console.log('p:',selected_payment_term_data);
  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
   TemplateName: false,
  });
const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
  const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();
    
       useEffect(() => {
           if (IdData) {
               itemDetails({ doctype: 'Payment Terms Template', name: IdData })
                   .unwrap()
                   .then((response) => {
                     const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                       setpodata(response)
                       console.log(item.terms, "Api response");
                       setTemplateName(item.template_name);
                       setAllocatePaymentBasedOnPaymentTerms(item.allocate_payment_based_on_payment_terms);
                       setselected_payment_term_data(item.terms);
                        setAttachmentsList(docinfo.attachments); // ✅ Correct place
                   })
                   .catch((err) => {
                       console.error('API Error:', err);
                   });
           } else {
               console.warn('No Id Data found in location state');
           }
       }, [IdData, itemDetails]);


  const handleSubmit = async () => {

//  console.log('tbl:',selected_payment_term_data)
const totalPortion = selected_payment_term_data.reduce((sum, row) => sum + parseFloat(row.invoice_portion || 0), 0);

  if (totalPortion !== 100) {
    setptype("Error");
      setError("Combined invoice portion must equal 100%");
      setShowError(true);
      return;
   
  }
    setFieldErrors({
      TemplateName: false,
    });

    let hasError = false;
    const newErrors = {
      TemplateName: !TemplateName,
    };

    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some((error) => error);

    if (!TemplateName) {
      setptype("Error");
      setError("Please Fill Template Name.");
      setShowError(true);
      return;
    }
   

  const payload = {
  template_name: IdData,
  allocate_payment_based_on_payment_terms: AllocatePaymentBasedOnPaymentTerms,
  terms: selected_payment_term_data ? selected_payment_term_data : [],
};


  console.log("update payment terms template payload:", payload);
    try {
      const response = await UpdatePaymentTermsTemplate(payload).unwrap();  // .unwrap() if you want direct data/handling


       function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Updation failed";

  if (response.error.data && response.error.data.exception) {
    try {
      const serverMessages = JSON.parse(response.error.data.exception);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse exception", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

      setpo_response(response.data);
      setError("Payment Terms template updated successfully!");
      setptype("Success");
      setShowError(true);
      // Navigate after a short delay (e.g., 2 seconds)
      setTimeout(() => {
        navigate("/master/payment-term-template/payment-term-template-list"); // 🔁 Replace with your actual route
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }
  };
  return (
    <FormLayout
      title="Edit Payment Terms Template"
      breadcrumbs={[
         { label: "Payment Terms Template"},
        { label: "Payment Terms Template List", url: "/master/payment-term-template/payment-term-template-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="#"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

             {/* <FileAttachmentManager
  doctype="Payment Terms Template"
  docname={IdData}
  attachments={AttachmentsList}
  setAttachments={setAttachmentsList}
/> */}

         <Attachment doctype="Payment Terms Template"  docname={IdData}  />    
          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2"  style={{height:'100vh'}}>
                  <Tab1
                  IdData={IdData}
  setselected_payment_term_data={setselected_payment_term_data}
                      selected_payment_term_data={selected_payment_term_data}
                    TemplateName={{
                      TemplateName: TemplateName,
                      setTemplateName: setTemplateName,
                      TemplateName: TemplateName,
                      Error: fieldErrors.TemplateName,
                    }}
  
                    AllocatePaymentBasedOnPaymentTerms={{
                      AllocatePaymentBasedOnPaymentTerms: AllocatePaymentBasedOnPaymentTerms,
                      setAllocatePaymentBasedOnPaymentTerms: setAllocatePaymentBasedOnPaymentTerms,
                      AllocatePaymentBasedOnPaymentTerms: AllocatePaymentBasedOnPaymentTerms,
                      Error: fieldErrors.AllocatePaymentBasedOnPaymentTerms,
                    }}
                    
                    
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default EditForm;
